import React from 'react';
import { Redirect } from 'react-router-dom';

export const AuthCallback = () => {
  return (
    <Redirect to={'/'} push/>
  );
};
